import { TFunction } from 'i18next';

import { EntityExportDto, EntityExportDtoRuleEnum } from 'src/Services/API/generated';

// t('contacts.exportName.count_one', 'Export de {{count}} contact')
// t('contacts.exportName.count_other', 'Export de {{count}} contacts')

export const contactExportNameGenerator = (
  contactExport: EntityExportDto,
  t: TFunction<'translation', undefined>
): string => {
  if (contactExport.rule === EntityExportDtoRuleEnum.All) {
    return t('contacts.exportName.all', 'Tous les contacts');
  }

  if (contactExport.rule === EntityExportDtoRuleEnum.Emergency) {
    return t('contacts.exportName.emergency', "Contacts d'urgence");
  }

  return t('contacts.exportName.count', { count: contactExport.entityIds?.length ?? 1 });
};
